import { c as _c } from "react/compiler-runtime";
import SpecificTriggerRules from 'modules/automation-rules/specific-trigger-rules';
import { getDefaultTriggerValue } from 'modules/automation-rules/triggers/utils/get-default-trigger-value';
import { useFunnelStepRuleData } from 'modules/funnels/funnel/components/funnel-rules/hooks/use-funnel-step-rule-data';
import { useFunnelStepRules } from 'modules/funnels/funnel/components/funnel-rules/hooks/use-funnel-step-rules';
import { useFunnelStepTriggers } from 'modules/funnels/funnel/components/funnel-rules/hooks/use-funnel-step-triggers';
import { fillTriggerWithFunnelData } from 'modules/funnels/funnel/components/funnel-rules/utils/fill-trigger-with-funnel-data';
import MobileSettingsHeader from 'modules/funnels/funnel/components/mobile-settings-header';
import { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum';
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { splitRelatedAndUnrelatedTriggers } from '../utils/split-related-and-unrelated-triggers';
interface AutomationRulesSectionProps {
  funnelStepId?: FunnelStepId;
  funnelId: FunnelId;
}
function AutomationRulesTab(t0) {
  const $ = _c(13);
  const {
    funnelId,
    funnelStepId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const specificTriggerRulesData = useFunnelStepRules(funnelStepId);
  const availableTriggersData = useFunnelStepTriggers(funnelStepId);
  const {
    funnelTriggerData
  } = useFunnelStepRuleData(funnelId, funnelStepId);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="px-4 lg:hidden"><MobileSettingsHeader type={FunnelStepSettingTabsEnum.automationRules} /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = id => <TransLoco t={t} components={{
      a: <LinkWithoutPrefetch href={`/automation-rules/${id}`} className="primary-link" />
    }} i18nKey="dashboard.automation_rule.trigger.has_non_related" />;
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== funnelTriggerData?.funnelStepId) {
    t3 = triggers => splitRelatedAndUnrelatedTriggers(triggers, funnelTriggerData?.funnelStepId);
    $[3] = funnelTriggerData?.funnelStepId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== funnelTriggerData) {
    t4 = funnelTriggerData && ((trigger, maxTriggerId) => fillTriggerWithFunnelData(getDefaultTriggerValue(trigger, maxTriggerId), funnelTriggerData));
    $[5] = funnelTriggerData;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== availableTriggersData || $[8] !== specificTriggerRulesData || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <>{t1}<SpecificTriggerRules noRelatedMessage={t2} availableTriggersData={availableTriggersData} specificTriggerRulesData={specificTriggerRulesData} getRelatedAndUnrelatedTriggersData={t3} customAddTriggerHandler={t4} /></>;
    $[7] = availableTriggersData;
    $[8] = specificTriggerRulesData;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
export default AutomationRulesTab;